module.exports = __webpack_public_path__ + "static/media/beer.58211f73.svg";